var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8264 39.0242C9.1773 39.0242 0.513672 30.3605 0.513672 19.7115C0.513672 9.06243 9.1773 0.398804 19.8264 0.398804C30.4754 0.398804 39.139 9.06243 39.139 19.7115C39.139 30.3605 30.4754 39.0242 19.8264 39.0242ZM29.8416 26.4959C29.9561 26.4958 30.0659 26.4502 30.1469 26.3692C30.2278 26.2883 30.2734 26.1785 30.2735 26.064V13.9395L20.4475 21.7424C20.2656 21.8869 20.0459 21.9591 19.8263 21.9591C19.6067 21.9591 19.387 21.8868 19.2051 21.7424L9.3791 13.9395V26.064C9.37924 26.1785 9.42479 26.2883 9.50575 26.3692C9.58672 26.4502 9.69649 26.4958 9.81099 26.4959H29.8416ZM28.3359 12.9271L19.8264 19.6846L11.3168 12.9271H28.3359ZM32.2714 13.359V26.0642C32.2714 27.4039 31.1814 28.4939 29.8416 28.4939H9.81099C8.47118 28.4939 7.38129 27.4039 7.38129 26.0642V13.359C7.38129 12.0192 8.47125 10.9293 9.81099 10.9293H29.8416C31.1814 10.9292 32.2714 12.0192 32.2714 13.359Z",
    fill: "#1C6A3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.29312b1465aed39e337d83340c642d0c.svg";
export { ForwardRef as ReactComponent };